module.exports = __webpack_public_path__ + "static/media/MeetingBg.519e04b3.png";